module.exports = __webpack_public_path__ + "static/media/globe.63364dd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/globe.svg
// module id = 2023
// module chunks = 0